import { usePoSelectedPeripheralFinanceModel } from '@/services/purchaseOrders/usePurchaseOrderService';
import { usePrintCurrencyStringForCurrentCustomer } from '@/utils/price';
import { FunctionComponent } from 'react';

interface PurchaseOrderConfirmOrderDeviceTablePeripheralPCMFieldProps {
  totalPrice: number;
}

const PurchaseOrderConfirmOrderDeviceTablePeripheralPCMField: FunctionComponent<
  PurchaseOrderConfirmOrderDeviceTablePeripheralPCMFieldProps
> = ({ totalPrice }) => {
  const model = usePoSelectedPeripheralFinanceModel();

  const printCurrencyString = usePrintCurrencyStringForCurrentCustomer();
  const price = printCurrencyString(totalPrice * (model ? model.pcmFactor : 0));

  return <span>{model && model.pcmFactor ? price : '-'}</span>;
};

export default PurchaseOrderConfirmOrderDeviceTablePeripheralPCMField;
